<template>
  <div class="top-panel">
    <div class="tp-left">
      <LazyIcon name="logoIcon" :size="22" style="margin: 4px;" />
      <div class="tp-title">{{ title || '未命名的项目' }}</div>
    </div>

    <div v-if="showToolbar" class="tp-toolbar" role="toolbar" aria-label="显示/隐藏面板">
      <button
        class="toolbar-btn"
        :class="{ active: leftVisible }"
        @click="$emit('toggle-left')"
        title="管理面板">
        <LazyIcon :name="'leftIcon-hover'" :size="12" />
      </button>
      <button
        class="toolbar-btn"
        :class="{ active: bottomVisible }"
        @click="$emit('toggle-bottom')"
        title="日志面板">
        <LazyIcon :name="'logIcon-hover'" :size="12" />
      </button>
      <button
        class="toolbar-btn"
        :class="{ active: miniMapVisible }"
        @click="$emit('toggle-minimap')"
        title="切换小地图显示">
        <LazyIcon :name="'minimapIcon-hover'" :size="12" />
      </button>
    </div>

    <div class="tp-right">
      <div class="tp-status">
        <div class="tp-status-label">最近保存</div>
        <div class="tp-status-time">{{ lastSavedText }}</div>
      </div>
      <button class="tp-save" :disabled="!canSave" @click="$emit('save')">
        <ElIcon  style="font-size: 14px;">
          <Promotion />
        </ElIcon>
        保存</button>
    </div>
  </div>
  
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import { LazyIcon } from '@/exports/components'

import { Promotion, ElIcon } from '@/plugins/elementPlus'
const props = defineProps<{ 
  title?: string; 
  lastSavedAt?: Date | number | string; 
  canSave?: boolean;
  showToolbar?: boolean;
  leftVisible?: boolean;
  bottomVisible?: boolean;
  miniMapVisible?: boolean;
}>()

const lastSavedText = computed(() => {
  const v = props.lastSavedAt
  if (!v) return '----'
  try {
    const d = new Date(v)
    return d.toLocaleString('zh-CN', { hour12: false })
  } catch {
    return String(v)
  }
})

const canSave = computed(() => props.canSave ?? true)
</script>

<style scoped lang="scss">
.top-panel {
  --tp-bg: #1f1f1f;
  --tp-border: #3a3a3a;
  --tp-text: #cfcfcf;
  --tp-text-secondary: #999999;
  --tp-primary: var(--mflow-color-primary);

  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 40px;
  padding: 0px;
  padding-left: 12px;
  background: var(--tp-bg);
  border-bottom: 1px solid var(--tp-border);
  position: relative;
}
.top-panel::before {
  content: '';
  position: absolute;
  top: 0; left: 0; right: 0;
  height: 2px;
  background: var(--tp-primary);
}

.tp-left { display: flex; align-items: center; gap: 8px; }
.tp-back { 
  background: transparent; border: 1px solid var(--tp-border); color: var(--tp-text-secondary);
  width: 24px; height: 24px; border-radius: 4px; cursor: pointer; display: inline-flex; align-items: center; justify-content: center;
}
.tp-back:hover { background: #333; color: #fff; border-color: var(--tp-primary); }
.tp-title { color: var(--tp-text); font-size: 13px; font-weight: 600; }

/* Center toolbar migrated from editor */
.tp-toolbar {
  position: absolute;
  top: px;
  left: 50%;
  transform: translateX(-50%);
  display: inline-flex;
  gap: 8px;
  // background: rgba(0,0,0,0.25);
  // padding: 6px 8px;
  // border-radius: 8px;
  // backdrop-filter: blur(6px);
  // -webkit-backdrop-filter: blur(6px);
  // z-index: 1200;
}
.toolbar-btn {
  width: 20px;
  height: 20px;
  border-radius: 2px;
  // border: 1px solid rgba(255,255,255,0.08);
  background: #B0B0AE;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}
.toolbar-btn:hover { background: #4e96d6; border-color: #0089FF; }
.toolbar-btn.active { background: #0089FF; border-color: #0089FF; }

.tp-right { display: flex; align-items: center; gap: 8px; }
.tp-status { display: flex; flex-direction: column; align-items: flex-end; line-height: 1.2; }
.tp-status-label { color: var(--tp-text); font-size: 11px; }
.tp-status-time { color: var(--tp-text-secondary); font-size: 10px; }
.tp-save { 
  background: var(--tp-primary); color: #fff; border: 1px solid var(--tp-primary);
  height: 39px;width: 64px;  border-radius: 2px; font-size: 12px; cursor: pointer;
  margin-left: auto;
}
.tp-save:hover { filter: brightness(1.05); }
// .tp-save:disabled { opacity: .5; cursor: not-allowed; }
</style>
